// Tipos de documento LGPD (espelha o enum LgpdTypes do backend)
export const LgpdTypes = {
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TERMS_OF_USAGE: 'TERMS_OF_USAGE',
};

// Rótulo exibido para cada tipo de documento
export const LGPD_TYPE_LABEL = {
  [LgpdTypes.PRIVACY_POLICY]: 'Política de Privacidade',
  [LgpdTypes.TERMS_OF_USAGE]: 'Termos de Uso',
};

// Título da modal (igual nos modos aceite e rejeição)
export const MODAL_TITLE = 'Termos e condições';

// Mensagens de erro (doc §3.9)
export const ERROR_MESSAGES = {
  getDocumentsClient: {
    title: 'Erro ao recuperar documentos LGPD',
    message:
      'Ocorreu um erro ao recuperar os documentos LGPD, por favor, aguarde...',
  },
  getDocumentsServer: {
    title: 'Erro interno do servidor',
    message:
      'Ocorreu uma falha no nosso sistema, por favor, conecte-se novamente.',
  },
  signatures: {
    title: 'Erro ao assinar documentos',
    message:
      'Ocorreu um erro ao assinar os documentos LGPD. Por favor, tente novamente.',
  },
};

const PRONOUN = {
  [LgpdTypes.PRIVACY_POLICY]: 'nossa',
  [LgpdTypes.TERMS_OF_USAGE]: 'nossos',
};

// Lista os rótulos dos documentos no formato 'A e B' / 'A'
function joinLabels(types) {
  return types.map((type) => LGPD_TYPE_LABEL[type]).join(' e ');
}

// Texto do modo aceite, dinâmico conforme 1 ou 2 documentos pendentes (doc §3.8)
export function buildAcceptText(types) {
  if (types.length === 2) {
    return 'Para iniciar o Analyze, você precisa concordar com nossos Termos de Uso e Política de Privacidade.';
  }
  const [type] = types;
  return `Para iniciar o Analyze, você precisa concordar com ${PRONOUN[type]} ${LGPD_TYPE_LABEL[type]}.`;
}

// Texto do modo rejeição, dinâmico conforme 1 ou 2 documentos pendentes (doc §3.8)
export function buildRejectText(types) {
  const pronoun = types.length === 2 ? 'nossos' : PRONOUN[types[0]];
  return `Rejeitando ${pronoun} ${joinLabels(types)} você não terá acesso ao Analyze. Deseja mesmo rejeitar?`;
}
